module.exports = __webpack_public_path__ + "img/lb.bc789b2.svg";